export var SearchResultsState;
(function (SearchResultsState) {
    SearchResultsState[SearchResultsState["Empty"] = 0] = "Empty";
    SearchResultsState[SearchResultsState["Loading"] = 1] = "Loading";
    SearchResultsState[SearchResultsState["NoResults"] = 2] = "NoResults";
    SearchResultsState[SearchResultsState["HasResults"] = 3] = "HasResults";
})(SearchResultsState || (SearchResultsState = {}));
//# sourceMappingURL=SearchResultsState.js.map